import type HttpClient from "../../tastyworks/http"
import {
  OAUTH_APPLICATION_DESER,
  OauthApplication,
} from "../../tastyworks/oauth"
import {
  ItemsResponse,
  SingleResponse,
  updateSingleResponse,
} from "../../tastyworks/response"

export class OauthApplicationService {
  constructor(private readonly userMeClient: HttpClient) {}

  readonly index = async (): Promise<ItemsResponse<OauthApplication>> =>
    this.userMeClient.indexSimple(
      OAUTH_APPLICATION_DESER.toParser(OauthApplication),
      "/oauth/clients"
    )

  readonly show = async (
    clientId: string
  ): Promise<SingleResponse<OauthApplication>> =>
    this.userMeClient.show(
      new OauthApplication(),
      OAUTH_APPLICATION_DESER.update,
      `/oauth/clients/${clientId}`
    )

  readonly create = async (
    redirectUris: string[],
    scopes: string[]
  ): Promise<SingleResponse<OauthApplication>> => {
    const app = new OauthApplication()
    app.redirectUris = redirectUris
    app.scopes = scopes

    return this.userMeClient.create(
      app,
      OAUTH_APPLICATION_DESER.serialize,
      OAUTH_APPLICATION_DESER.update,
      "/oauth/clients"
    )
  }

  readonly update = async (
    app: OauthApplication,
    regenerateSecret = false
  ): Promise<SingleResponse<OauthApplication>> => {
    const params = {
      "redirect-uris": app.redirectUris,
      scopes: app.scopes,
      "regenerate-secret": regenerateSecret,
    }
    const helper = await this.userMeClient.patch(
      "/oauth/clients/:clientId",
      params,
      {
        clientId: app.clientId,
      }
    )
    return updateSingleResponse(
      helper,
      new OauthApplication(),
      OAUTH_APPLICATION_DESER.update
    )
  }
}
